import { Box, Label } from '@primer/react';
import { EyeIcon, PencilIcon, TrashIcon, HeartFillIcon, LocationIcon, FilterIcon } from '@primer/octicons-react';
import UserAvatar from '../../components/user-avatar';
import React from 'react';

interface ILiveCheckInHocSinhProps {
    data: any
}

const LiveCheckInHocSinh = ({ data }: ILiveCheckInHocSinhProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                gridTemplateColumns: "100px 300px 120px",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid",
                borderBottomColor: "border.default",
                py: 2
            }}
            key={data.key}
            className="anim-checkin"
        >
            {/* Left: Avatar + Info */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                <UserAvatar url={data.image_url} borderRadius='8px' fullName={data.ho_ten} size={'xxxlarge'} />

                <Box>
                    <Box sx={{ fontWeight: 600, fontSize: 16, color: "accent.fg", cursor: "pointer" }}>
                        {data.ho_ten}
                    </Box>
                    <Box sx={{ fontSize: 13, color: "fg.muted", display: "flex", alignItems: "center", gap: 2 }}>
                        <FilterIcon size={14} />Mã Hs:<span style={{fontWeight:'600'}}>{data.ma_hs || "N/A"}</span>
                        <LocationIcon size={14} />Lớp:<span style={{fontWeight:'600'}}>{data.ten_lop || "N/A"}</span>
                    </Box>
                </Box>
            </Box>
            {/* Right: Actions */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                {!data.gio_diem_danh &&
                    <Label sx={{
                        backgroundColor: "severe.muted",
                        color: "severe.emphasis",
                        borderRadius: 2,
                        p: 2
                    }} > Chưa điểm danh </Label>
                }
                {data.gio_diem_danh &&
                    <>
                        {data.is_dang_ky_an ?
                            (
                                <Label sx={{
                                    backgroundColor: "success.subtle", color: "success.emphasis",
                                    borderRadius: 2,
                                    p: 2
                                }}>
                                    {data.gio_diem_danh.substring(0, 8)}
                                </Label>
                            ) : (
                                <Label sx={{
                                    backgroundColor: "danger.muted", color: "danger.emphasis",
                                    borderRadius: 2,
                                    p: 2
                                }}>
                                    {data.gio_diem_danh.substring(0, 8)}
                                </Label>
                            )}
                    </>
                }
            </Box>
        </Box>
    );
};

export default LiveCheckInHocSinh;
